import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { apiErr } from "../lib/api";
import { useCustomer } from "../context/CustomerContext";

export default function CustomerCallback() {
  const { googleCustomer } = useCustomer();
  const nav = useNavigate();
  const [err, setErr] = useState(false);

  useEffect(() => {
    const hash = window.location.hash;
    const sid = hash.includes("session_id=")
      ? new URLSearchParams(hash.replace("#", "")).get("session_id")
      : null;
    if (!sid) { nav("/"); return; }
    googleCustomer(sid)
      .then(() => { window.history.replaceState(null, "", "/my-bookings"); nav("/my-bookings"); })
      .catch((e) => { toast.error(apiErr(e)); setErr(true); });
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-background">
      {err ? (
        <p className="text-muted-foreground">تعذر تسجيل الدخول. <button onClick={() => nav("/")} className="text-primary underline">العودة</button></p>
      ) : (
        <div className="text-center"><Loader2 className="h-10 w-10 animate-spin text-primary mx-auto" /><p className="mt-3 text-muted-foreground">جارٍ تسجيل الدخول...</p></div>
      )}
    </div>
  );
}
